import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

// Async thunk to start/stop a VM
export const updateAWSDBState = createAsyncThunk(
  "aws/updateAWSDBState",
  async ({ accountId, resourceId,dbType, action }, { rejectWithValue }) => {
    try {
        const res = await httpInterceptor.post(
          `/resources/aws/rds?account=${accountId}&database=${resourceId}&db_type=${dbType}&action=${action}`
        );
      // Assuming API returns updated VM object
      return { accountId, vm: res.data };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update VM state"
      );
    }
  }
);

// Initial state
const initialState = {
  loading: false,
  updatedVm: null, // updated VM after API call
  error: false,
  errorMessage: "",
};

const updateAWSDBStateSlice = createSlice({
  name: "updateAWSDBState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateAWSDBState.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.errorMessage = "";
        state.updatedVm = null;
      })
      .addCase(updateAWSDBState.fulfilled, (state, action) => {
        state.loading = false;
        state.updatedVm = action.payload; // contains accountId + updated vm object
      })
      .addCase(updateAWSDBState.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errorMessage = action.payload;
        state.updatedVm = null;
      });
  },
});

export default updateAWSDBStateSlice.reducer;
